const pageNav = {
  init() {
    const mobileSelect = document.querySelector('[data-general-content-nav]');

    if (mobileSelect) {
      mobileSelect.addEventListener('change', (event) => {
        const selectedUrl = event.target.value;
        if (selectedUrl && window.location.href !== selectedUrl) {
          try {
            new URL(selectedUrl, window.location.origin);
            window.location.href = selectedUrl;
          } catch (error) {
            console.error('Invalid URL for navigation:', selectedUrl, error);
          }
        }
      });
    }
  },
};

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', pageNav.init);
